<template lang="pug">
  d-input-base(
    component="v-autocomplete"
    v-bind="extendAttrs"
    v-on="$listeners"
  )
    template(
      v-for="(_, name) in $scopedSlots"
      v-slot:[name]="data"
    )
      slot(:name="name" v-bind="data")
    template(
      v-for="(_, name) in $slots"
      :slot="name"
    )
      slot(:name="name")
</template>

<script>
import DInputBase from './DInputBase.vue';
import VAutocomplete from 'vuetify/lib/components/VAutocomplete/VAutocomplete';

export default {
  components:  {
    DInputBase,
    VAutocomplete,
  },
  props: {
    returnObject: {
      type: Boolean,
      default: false,
    },
    itemValue: {
      type: String,
      default: 'id',
    },
    items: {
      type: Array,
      default: () => [],
    },
    meta: {
      type: Object,
      default: undefined,
    },
    value: {
      type: [String, Number, Array, Object, Boolean],
      default: undefined,
    },
  },
  watch: {
    items: {
      handler(val) {
        if (val?.length) this.updateMeta();
      },
      immediate: true,
    },
    value(val) {
      this.updateMeta(val);
    },
  },
  computed: {
    extendAttrs() {
      const { value, items, returnObject, itemValue } = this;

      return {
        placeholder: 'Выберите...',
        appendIcon: '$ui-chevron-down',
        returnObject,
        height: 48,
        itemValue,
        items,
        value,
        ...this.$attrs,
      };
    },
  },
  methods: {
    updateMeta(val = this.value) {
      const { getMeta } = this;
      this.$emit('update:meta', getMeta(val));
    },
    getMeta(val) {
      const { returnObject } = this;

      if (returnObject || [undefined, null].includes(val)) return undefined;

      const { items, itemValue } = this;
      const itemData = (items || [])?.find?.((i) => i?.[itemValue] === val);

      return itemData;
    },
  },
};
</script>
